import { ReactElement } from "react";

import AyaLogo from "../../../../assets/images/common/png/aya_logo.png";

type Props = Readonly<{}>;

function MainHeader(props: Props): ReactElement {
    return (
        <div id="banner-container">
            <div id="banner-left-margin" />
            <div id="banner-contents">
                <a href="/">
                    <img src={AyaLogo} alt="Ayaseye" />
                </a>
            </div>
            <div id="banner-right-margin" />
        </div>
    );
}

export default MainHeader;
